import styled from 'styled-components'

import type { ClassNameProps } from '@root/shared/lib/react'

type PremiumSliderImageProps = {
  svg: string
} & ClassNameProps

// Rendered as inline markup (not <img>) so the SVG resolves page CSS
// variables (--text-12, --appearance-inv-1) and adapts to the theme.
export const PremiumSliderImage: React.FC<PremiumSliderImageProps> = ({
  svg,
  className,
}) => <Root className={className} dangerouslySetInnerHTML={{ __html: svg }} />

const Root = styled.span`
  display: block;
  width: var(--slider-image-width, 100%);
  height: 100%;
  position: relative;

  margin: 0 auto;
  z-index: -1;

  svg {
    display: block;
    width: 100%;
    height: 100%;
  }
`
